import React from 'react';
import { BannerInvitePartner } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import { showModal, closeModal, setLastRequestTime } from '../../../Utils';
import api from '../../../actions/EndPoints';
import axiosInstance from '../../../actions/AxiosInstance';
import { dispatchOverlayLoad } from '../../shared/Analytics';
import { GENERAL_HUB_ERROR_MODAL, INVITE_PARTNER_MODAL, HUB_GENERAL_ERROR_OVERLAY } from '../../../Constants';

const InvitePartnerModal = ({ state }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [invitePayload, setInvitePayload] = React.useState(null);
    const [fieldsError, setFieldsError] = React.useState(false);
    const [partnerEmail, setEmail] = React.useState("");
    const [partnerPin, setPin] = React.useState("");

    const getValidEmail = (email) => /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+.[a-zA-Z]{2,4}$/.test(email);
    const getValidPin = (pin) => pin?.length === 4 && /^\d*$/.test(pin);

    const emailRoot = document?.querySelectorAll(`[id="invite-partner-email-input"]`)[0];
    const pinRoot = document?.querySelectorAll(`[id="invite-partner-pin-input"]`)[0];

    const emailProspControl = document.querySelectorAll('#invite-partner-email-control')[0];
    const pinProspControl = document.querySelectorAll('#invite-partner-pin-control')[0];

    React.useEffect(() => {
        if (fieldsError && !partnerEmail) { emailRoot?.checkValidity(); }
        if (fieldsError && !partnerPin) { pinRoot?.checkValidity(); }

        if (partnerEmail && !getValidEmail(partnerEmail)) {
            emailProspControl.setAttribute('invalid', '')
        }

        if (partnerPin && !getValidPin(partnerEmail)) {
            pinProspControl.setAttribute('invalid', '')
        }

        if (getValidEmail(partnerEmail)) { emailProspControl.removeAttribute('invalid')}
        if (getValidPin(partnerPin)) { pinProspControl.removeAttribute('invalid')}

        if (partnerEmail && partnerPin && getValidEmail(partnerEmail) && getValidPin(partnerPin)) { setFieldsError(false) }
    }, [partnerEmail, partnerPin, fieldsError])

    const handleInvitePartner = () => {
        const isValidEmail = getValidEmail(partnerEmail);
        const isValidPin = getValidPin(partnerPin);

        if (isValidEmail && isValidPin) {
            setFieldsError(false);
            postInvitePartner().then(() => setIsLoading(false))
        }

        if (!isValidEmail) {
            setFieldsError(true);
            emailProspControl.setAttribute('invalid', '')
        }

        if (!isValidPin) {
            setFieldsError(true);
            pinProspControl.setAttribute('invalid', '')
        }
    };

    async function postInvitePartner() {
        setIsLoading(true);
        try {
            const postCall = await axiosInstance.post(
                api.inviteCoClientAPI,
                {
                    emailAddress: invitePayload?.partnerEmail,
                    invitePinNumber: invitePayload?.partnerPin
                },
                {
                    headers: { apikey: `${state?.apiKey}` }
                }
            );

            if (postCall) {
                setLastRequestTime();
                openConfirmationModal();
                setIsLoading(false);
            }
        }
        catch (error) {
            const showErrorModalPromise = Promise.resolve(showModal(GENERAL_HUB_ERROR_MODAL));
            showErrorModalPromise
                .then(() => console.log(error))
                .then(() =>
                    closeModal(INVITE_PARTNER_MODAL)
                )
                .then(() => dispatchOverlayLoad(HUB_GENERAL_ERROR_OVERLAY))
                .then(() => setLastRequestTime())
                .then(() => {
                    setIsLoading(false);
                });
        }
    }

    const cancelClick = () => {
        closeModal(INVITE_PARTNER_MODAL);
    };

    const openConfirmationModal = () => {
        showModal('banner-invite-confirmation-modal');
        dispatchOverlayLoad('Invite Partner Confirmation Modal');
        closeModal(INVITE_PARTNER_MODAL);
    };

    React.useEffect(() => {
        setInvitePayload({
            partnerEmail,
            partnerPin
        })
    }, [partnerEmail, partnerPin]);

    return (
        <BannerInvitePartner
            id={'invite-partner'}
            leftBtnText={'Cancel'}
            loadingTitle={'Inviting co-client...'}
            loadingText={'One moment while we invite your co-client...'}
            isLoading={isLoading}
            createClick={() => handleInvitePartner()}
            cancelClick={cancelClick}
            setEmail={setEmail}
            setPin={setPin}
            email={partnerEmail}
            pin={partnerPin}
        />
    )
};

export default InvitePartnerModal;